import React from "react";

const PHASES = [
  { tag: "phase 1", title: "be retarded", body: "we launch. we hold. we vibrate.", color: "#F4A261" },
  { tag: "phase 2", title: "get retarded holders", body: "memes everywhere. propeller hats irl. moms confused.", color: "#2A9D8F" },
  { tag: "phase 3", title: "retarded price", body: "the chart goes up. or sideways. or down. but with style.", color: "#457B9D" },
  { tag: "phase 4", title: "??? profit?", body: "we don't know. nobody knows. that's the whole point.", color: "#E63946" },
];

export const Roadmap = () => {
  return (
    <section className="px-5 md:px-10 py-14" data-testid="roadmap-section">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-display text-5xl md:text-7xl">
            the <span className="text-[#E8742C]">retarded</span> roadmap
          </h2>
          <p className="text-lg md:text-xl text-[#1A1A1A]/70 mt-2">
            drawn on a napkin. we lost the napkin. doing it from memory.
          </p>
        </div>

        <div className="relative grid grid-cols-1 md:grid-cols-4 gap-6">
          {/* squiggly connector */}
          <svg
            viewBox="0 0 1200 60"
            preserveAspectRatio="none"
            className="hidden md:block absolute top-12 left-0 w-full h-12 z-0"
            aria-hidden="true"
          >
            <path
              d="M 20 30 Q 150 0 300 30 T 600 30 T 900 30 T 1180 30"
              stroke="#1A1A1A"
              strokeWidth="5"
              strokeDasharray="2 10"
              fill="none"
            />
          </svg>

          {PHASES.map((p, idx) => (
            <div
              key={p.tag}
              className="relative crayon-card px-5 py-6 z-10"
              style={{ transform: `rotate(${idx % 2 ? 1.5 : -1.5}deg)` }}
              data-testid={`roadmap-phase-${idx + 1}`}
            >
              <div
                className="absolute -top-5 left-1/2 -translate-x-1/2 px-4 py-1 border-3 border-[#1A1A1A] rounded-full font-display text-xl text-white shadow-[3px_3px_0_#1A1A1A]"
                style={{ background: p.color, borderWidth: 3, borderStyle: "solid", borderColor: "#1A1A1A" }}
              >
                {p.tag}
              </div>
              <h3 className="font-display text-3xl mt-3 text-center">{p.title}</h3>
              <p className="text-base md:text-lg text-center text-[#1A1A1A]/80 mt-2">
                {p.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Roadmap;
